var _rect, _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnetime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.53516,
    y: 13.2578,
    width: 25.3359,
    height: 16.8906,
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7065 15.4297H14.0847",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3213 27.9766L31.6994 27.9766",
    stroke: "black",
    strokeWidth: 1.07812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2034,
    cy: 21.7024,
    r: 1.60863,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0095,
    cy: 31.2053,
    r: 8.39669,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 0.730147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6443 35.0331C34.8811 35.0331 34.1961 34.56 33.9184 33.8414L33.5587 32.9116C33.5218 32.8271 33.4826 32.7724 33.4411 32.747C33.3994 32.7217 33.3317 32.709 33.2382 32.709H33.0781L32.9833 33.495C32.8773 34.373 32.1402 35.0331 31.2656 35.0331L32.0001 28.991C32.1067 28.113 32.8442 27.4531 33.7191 27.4531L33.2034 31.7014H33.3084C33.3953 31.7014 33.4652 31.6879 33.5187 31.661C33.572 31.6341 33.6256 31.5851 33.6789 31.5141L34.4313 30.4716C34.7397 30.0444 35.23 29.7905 35.7529 29.7876L36.6329 29.7825L35.1809 31.6509C35.114 31.7387 35.0407 31.8165 34.9605 31.8838C34.8804 31.9514 34.7968 32.0105 34.7102 32.061C34.7804 32.1185 34.8412 32.1851 34.8929 32.261C34.9447 32.3369 34.9905 32.424 35.0305 32.5219L36.0719 35.0334H35.6443V35.0331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetime);
export default __webpack_public_path__ + "static/media/onetime.b423f3737fdecefb57b86021f6550976.svg";
export { ForwardRef as ReactComponent };